<template>
  <v-data-table
    :headers="headers"
    :items="healthCheckResults"
    sort-by="healthCheckOccurredAt"
    :items-per-page="-1"
    fixed-header
    dense
    hide-default-footer
    :no-data-text="$t('profile.history.noData')"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-subheader class="subtitle font-weight-bold text-uppercase">{{
          $t("reports.healthChecks.title")
        }}</v-subheader>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>

    <template v-slot:[`item.healthCheckOccurredAt`]="{ item }">
      {{ item.healthCheckOccurredAt | date }}
    </template>

    <template v-slot:[`item.nextHealthCheckDateTime`]="{ item }">
      {{ item.nextHealthCheckDateTime | date }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    healthCheckResults: {
      type: Array,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$i18n.t("healthCheck.result.healthCheckDate"),
          value: "healthCheckOccurredAt",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("healthCheck.result.decision"),
          value: "result",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("healthCheck.result.suggestion"),
          value: "suggestion",
          class: "text-uppercase subheading text-truncate",
        },
        {
          text: this.$i18n.t("healthCheck.result.nextHealthCheckDate"),
          value: "nextHealthCheckDateTime",
          class: "text-uppercase subheading text-truncate",
        },
      ];
    },
  },
};
</script>
